import { useState, useRef, useEffect } from 'react';

const useTimer = (isActiveInitially) => {
  const [time, setTime] = useState(0);
  const [isActive, setIsActive] = useState(isActiveInitially);
  const countRef = useRef(null);

  const start = () => {
    setIsActive(true);
    countRef.current = setInterval(() => {
      setTime((prevTime) => prevTime + 1);
    }, 1000);
  };

  const stop = () => {
    setIsActive(false);
    if (countRef.current) {
      clearInterval(countRef.current);
    }
  };

  const reset = () => {
    setIsActive(false);
    if (countRef.current) {
      clearInterval(countRef.current);
    }
    setTime(0);
  };

  const pause = () => {
    setIsActive(false);
    if (countRef.current) {
      clearInterval(countRef.current);
    }
  };

  const resume = () => {
    if (!isActive) {
      setIsActive(true);
      countRef.current = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
  };

  useEffect(() => {
    if (isActiveInitially) {
      start();
    }
    return () => {
      if (countRef.current) {
        clearInterval(countRef.current);
      }
    };
  }, [isActiveInitially]);

  return { time, isActive, start, stop, reset, pause, resume };
};

export default useTimer;
